import { CSSProperties } from 'react';
import { IFormField } from '@vivli/shared/infrastructure/interface';
import { BaseControlledFormFieldComponent } from './base-controlled-form-field.component';
import { CheckboxComponent } from '../input/checkbox.component';

interface CheckboxFormFieldComponentProps extends IFormField {
    reverseOrientation?: boolean;
    name: string;
    inputStyle?: CSSProperties;
    disabled?: boolean;
    index?: number;
}

export const CheckboxFormFieldComponent = (props: CheckboxFormFieldComponentProps) => {
    return (
        <BaseControlledFormFieldComponent {...props}>
            <CheckboxComponent {...props} />
        </BaseControlledFormFieldComponent>
    );
};
